
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqD9Hirmk7tgaaBrZmLrAyuQtEgzLBw1CJ7j6DLBpi_s0Meta } from "F:/Projects/taminify_com-front/pages/faq.vue?macro=true";
import { default as aboutV8z_45SxTPgM5X0VNp8PbZvwUTckyAddm2LRzezmxKPS4Meta } from "F:/Projects/taminify_com-front/pages/about.vue?macro=true";
import { default as indexIz8YKf9AcVymbOIy7e1dpx7fQXgm59GKUp1SbM_HrzgMeta } from "F:/Projects/taminify_com-front/pages/index.vue?macro=true";
import { default as termsdNeEs3MRJcjwSbSyhV6uVMy6uTF_45cSwv2GOxVpV1MdcMeta } from "F:/Projects/taminify_com-front/pages/terms.vue?macro=true";
import { default as index8pvqdvZPczakjqTAYHLWGONh0cxRQ9NTDUDiuvRwUFUMeta } from "F:/Projects/taminify_com-front/pages/blog/index.vue?macro=true";
import { default as _91slug_93tIXeN2y_vu7ppVA09kxrO5o9W8UmMdSKvsUzh8ATv4cMeta } from "F:/Projects/taminify_com-front/pages/blog/[slug].vue?macro=true";
import { default as cartInK4sTBEf8Al5gs5qtFoFkuGYUDnxik34BA_458LKoUtoMeta } from "F:/Projects/taminify_com-front/pages/(store)/cart.vue?macro=true";
import { default as checkout7U4FOPYblbckRxTJHKEOMq_LK8hD5eKN_kaPUYP1qyMMeta } from "F:/Projects/taminify_com-front/pages/(store)/checkout.vue?macro=true";
import { default as trackingCkzRd_45UTpda7RCPpHgPtPTMsg7CzUuc4_kfngcpdMHMMeta } from "F:/Projects/taminify_com-front/pages/(store)/tracking.vue?macro=true";
import { default as callbackpQgZW1bKMn4NXh2nMwL8_9vSv9Z72ft7mXa_45UUUu0XQMeta } from "F:/Projects/taminify_com-front/pages/payment/callback.vue?macro=true";
import { default as cartUl2mEQRD7RBzwfGUV_NAVCFYFsFkPOPUYHwKW5VWEnIMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/cart.vue?macro=true";
import { default as aboutsOx6xpqgZEqMZ6ldwdnqjm_45lPHcHJVkAdDNM_odv7hUMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/about.vue?macro=true";
import { default as indexyY5HBkmx96mM6iwgQNQMPm1RxagA_452v3z_45V7_45xxA7NoMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/index.vue?macro=true";
import { default as checkoutE8cSkJfreFV_45WZcYFsJI_45GTBFB5uNRq3qK_45iJ7twYYgMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/checkout.vue?macro=true";
import { default as trackingpepRCadKPFamepjPOyVsrLXvxw4RHIxbKrVWVrZF9uAMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/tracking.vue?macro=true";
import { default as indexV_45c9P1QKtvc0jkby8mGMkJ44kIvSKLe7me6fI9tldvsMeta } from "F:/Projects/taminify_com-front/pages/(store)/categories/index.vue?macro=true";
import { default as indexRs5tRflrBpQVG_Yapkt78fbQb2Qp5H3yNbt4tjkA_SQMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/admin/index.vue?macro=true";
import { default as index5QtXpS3sZDa8rHs9ErL1Gvxk9v8gZAbCEJVe0l7_nkQMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/index.vue?macro=true";
import { default as loginLqJ4XEslsEI3P9WnKXnruyCtdsMi16XLJnaJH0EpFJ8Meta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/login.vue?macro=true";
import { default as registerogALVfW0CZAD1cQfLxRyJmXPUAvF2mcDOWFfvrAxCuUMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/register.vue?macro=true";
import { default as tracking_45by_45idv1INf8loX5PnQECRALQ1jFRviZXBCF1J0upkajk0QgsMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/tracking-by-id.vue?macro=true";
import { default as _91product_id_932yPuV3ILqJ02Mu1aGxw_EJUzMrUXvw9BZKUUUh9nWZ4Meta } from "F:/Projects/taminify_com-front/pages/(store)/products/[product_id].vue?macro=true";
import { default as indexoeR_45vy0CY3vdIMavhYrZfiE3zQsdYSXf7VvzPUAFekkMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/apps/index.vue?macro=true";
import { default as indexB8_3DjHRd_45O0dVf6aJPwuwg_454hPAXco2aYW3K07pbmgMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/admin/users/index.vue?macro=true";
import { default as indexzCesco6_459pVUn870ulRtWjrKRIdt9aDs2Y3R6KgCvoEMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/categories/index.vue?macro=true";
import { default as indexknUtY0clOU_45MBf_45VrE4qnr8NEdbC0NKFSkWdkW83jZUMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/parcels/index.vue?macro=true";
import { default as indexvmZD6b0bgQ2kNmkpb8UsoJce8eZrBsO3srNuEi7A_lsMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/admin/products/index.vue?macro=true";
import { default as index8KDTlUeK_WHH8rysQY37gBhO4Y3pzm1a7ISEf7NzmFgMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/products/index.vue?macro=true";
import { default as indextNHmuMgOkhbGXtdaGnlgrknTkfsqCWY0WMyGm1BQJVcMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/settings/index.vue?macro=true";
import { default as _91category_slug_93LqC4v8tm4G3oCKDJ32PCj7Pr_22c3kUY8gL_45BJoKplsMeta } from "F:/Projects/taminify_com-front/pages/(store)/categories/[category_slug].vue?macro=true";
import { default as indexk6_451YpCkhjfLdgwDiFfATvppaMTb12FQhjYXI7M4rlQMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/financial/index.vue?macro=true";
import { default as createcplngOtieQM5QIvg7quHwbri2bksCd9TreK2hJMPOHgMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/products/create.vue?macro=true";
import { default as _91product_id_932vf0Jyop1PDpVDc8oxnA_45rtztkGUEo52Ox0VyETJspoMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/products/[product_id].vue?macro=true";
import { default as editSp_458SaXGbMWdgJlVEl_a4lhiVhNdurD1yEFItS7k9XkMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/admin/products/[id]/edit.vue?macro=true";
import { default as edituVL22GNkvEvy6kK4lxbGSzpwBJOPxxZv_453ixSTX5H8MMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/panel/products/[id]/edit.vue?macro=true";
import { default as _91category_slug_931fnDM8iWgJN_45y2AQuuNVngmDD3VNF7dAcE4SJWl5qOUMeta } from "F:/Projects/taminify_com-front/pages/@[store_slug]/categories/[category_slug].vue?macro=true";
import { default as index9XgY6i1e1hMNwVbK3B95gOZM5TU1T2VG4mew_pRBC4kMeta } from "F:/Projects/taminify_com-front/pages/(subdomains)/admin/withdraw-requests/index.vue?macro=true";
import { default as component_45stubkYkKPjSnKaPaDPikbHaUPd4mS9NOOBaOZ_45kkFwfNJ9IMeta } from "F:/Projects/taminify_com-front/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubkYkKPjSnKaPaDPikbHaUPd4mS9NOOBaOZ_45kkFwfNJ9I } from "F:/Projects/taminify_com-front/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "landing.faq",
    path: "/faq",
    meta: faqD9Hirmk7tgaaBrZmLrAyuQtEgzLBw1CJ7j6DLBpi_s0Meta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/faq.vue")
  },
  {
    name: "landing.about",
    path: "/about",
    meta: aboutV8z_45SxTPgM5X0VNp8PbZvwUTckyAddm2LRzezmxKPS4Meta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/about.vue")
  },
  {
    name: "landing.home",
    path: "/",
    meta: indexIz8YKf9AcVymbOIy7e1dpx7fQXgm59GKUp1SbM_HrzgMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/index.vue")
  },
  {
    name: "landing.terms",
    path: "/terms",
    meta: termsdNeEs3MRJcjwSbSyhV6uVMy6uTF_45cSwv2GOxVpV1MdcMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/terms.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: index8pvqdvZPczakjqTAYHLWGONh0cxRQ9NTDUDiuvRwUFUMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/blog/index.vue")
  },
  {
    name: "blog.single",
    path: "/blog/:slug()",
    meta: _91slug_93tIXeN2y_vu7ppVA09kxrO5o9W8UmMdSKvsUzh8ATv4cMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/blog/[slug].vue")
  },
  {
    name: "store.cart",
    path: "/cart",
    meta: cartInK4sTBEf8Al5gs5qtFoFkuGYUDnxik34BA_458LKoUtoMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(store)/cart.vue")
  },
  {
    name: "store.checkout",
    path: "/checkout",
    meta: checkout7U4FOPYblbckRxTJHKEOMq_LK8hD5eKN_kaPUYP1qyMMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(store)/checkout.vue")
  },
  {
    name: "store.tracking",
    path: "/tracking",
    meta: trackingCkzRd_45UTpda7RCPpHgPtPTMsg7CzUuc4_kfngcpdMHMMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(store)/tracking.vue")
  },
  {
    name: "payment-callback",
    path: "/payment/callback",
    component: () => import("F:/Projects/taminify_com-front/pages/payment/callback.vue")
  },
  {
    name: "warehouse.cart",
    path: "/@:store_slug()/cart",
    meta: cartUl2mEQRD7RBzwfGUV_NAVCFYFsFkPOPUYHwKW5VWEnIMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/cart.vue")
  },
  {
    name: "warehouse.about",
    path: "/@:store_slug()/about",
    meta: aboutsOx6xpqgZEqMZ6ldwdnqjm_45lPHcHJVkAdDNM_odv7hUMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/about.vue")
  },
  {
    name: "warehouse.home",
    path: "/@:store_slug()",
    meta: indexyY5HBkmx96mM6iwgQNQMPm1RxagA_452v3z_45V7_45xxA7NoMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/index.vue")
  },
  {
    name: "warehouse.checkout",
    path: "/@:store_slug()/checkout",
    meta: checkoutE8cSkJfreFV_45WZcYFsJI_45GTBFB5uNRq3qK_45iJ7twYYgMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/checkout.vue")
  },
  {
    name: "warehouse.tracking",
    path: "/@:store_slug()/tracking",
    meta: trackingpepRCadKPFamepjPOyVsrLXvxw4RHIxbKrVWVrZF9uAMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/tracking.vue")
  },
  {
    name: "store.category",
    path: "/categories",
    meta: indexV_45c9P1QKtvc0jkby8mGMkJ44kIvSKLe7me6fI9tldvsMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(store)/categories/index.vue")
  },
  {
    name: "admin.dashboard",
    path: "/admin",
    meta: { ...(indexRs5tRflrBpQVG_Yapkt78fbQb2Qp5H3yNbt4tjkA_SQMeta || {}), ...{"middleware":["auth","authority"]} },
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/admin/index.vue")
  },
  {
    name: "supplier.dashboard",
    path: "/panel",
    meta: index5QtXpS3sZDa8rHs9ErL1Gvxk9v8gZAbCEJVe0l7_nkQMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/index.vue")
  },
  {
    name: "auth.login",
    path: "/panel/login",
    meta: loginLqJ4XEslsEI3P9WnKXnruyCtdsMi16XLJnaJH0EpFJ8Meta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/login.vue")
  },
  {
    name: "auth.register",
    path: "/panel/register",
    meta: registerogALVfW0CZAD1cQfLxRyJmXPUAvF2mcDOWFfvrAxCuUMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/register.vue")
  },
  {
    name: "warehouse.tracking-by-id",
    path: "/@:store_slug()/tracking-by-id",
    meta: tracking_45by_45idv1INf8loX5PnQECRALQ1jFRviZXBCF1J0upkajk0QgsMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/tracking-by-id.vue")
  },
  {
    name: "store.product",
    path: "/products/:product_id()",
    meta: _91product_id_932yPuV3ILqJ02Mu1aGxw_EJUzMrUXvw9BZKUUUh9nWZ4Meta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(store)/products/[product_id].vue")
  },
  {
    name: "supplier.apps",
    path: "/panel/apps",
    meta: indexoeR_45vy0CY3vdIMavhYrZfiE3zQsdYSXf7VvzPUAFekkMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/apps/index.vue")
  },
  {
    name: "admin.users.list",
    path: "/admin/users",
    meta: { ...(indexB8_3DjHRd_45O0dVf6aJPwuwg_454hPAXco2aYW3K07pbmgMeta || {}), ...{"middleware":["auth","authority"]} },
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/admin/users/index.vue")
  },
  {
    name: "warehouse.category",
    path: "/@:store_slug()/categories",
    meta: indexzCesco6_459pVUn870ulRtWjrKRIdt9aDs2Y3R6KgCvoEMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/categories/index.vue")
  },
  {
    name: "supplier.parcels",
    path: "/panel/parcels",
    meta: indexknUtY0clOU_45MBf_45VrE4qnr8NEdbC0NKFSkWdkW83jZUMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/parcels/index.vue")
  },
  {
    name: "admin.products.list",
    path: "/admin/products",
    meta: { ...(indexvmZD6b0bgQ2kNmkpb8UsoJce8eZrBsO3srNuEi7A_lsMeta || {}), ...{"middleware":["auth","authority"]} },
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/admin/products/index.vue")
  },
  {
    name: "supplier.products",
    path: "/panel/products",
    meta: index8KDTlUeK_WHH8rysQY37gBhO4Y3pzm1a7ISEf7NzmFgMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/products/index.vue")
  },
  {
    name: "supplier.settings",
    path: "/panel/settings",
    meta: indextNHmuMgOkhbGXtdaGnlgrknTkfsqCWY0WMyGm1BQJVcMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/settings/index.vue")
  },
  {
    name: "store.category.single",
    path: "/categories/:category_slug()",
    meta: _91category_slug_93LqC4v8tm4G3oCKDJ32PCj7Pr_22c3kUY8gL_45BJoKplsMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(store)/categories/[category_slug].vue")
  },
  {
    name: "supplier.financial",
    path: "/panel/financial",
    meta: indexk6_451YpCkhjfLdgwDiFfATvppaMTb12FQhjYXI7M4rlQMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/financial/index.vue")
  },
  {
    name: "supplier.products.create",
    path: "/panel/products/create",
    meta: createcplngOtieQM5QIvg7quHwbri2bksCd9TreK2hJMPOHgMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/products/create.vue")
  },
  {
    name: "warehouse.product",
    path: "/@:store_slug()/products/:product_id()",
    meta: _91product_id_932vf0Jyop1PDpVDc8oxnA_45rtztkGUEo52Ox0VyETJspoMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/products/[product_id].vue")
  },
  {
    name: "admin.products.edit",
    path: "/admin/products/:id()/edit",
    meta: { ...(editSp_458SaXGbMWdgJlVEl_a4lhiVhNdurD1yEFItS7k9XkMeta || {}), ...{"middleware":["auth","authority"]} },
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/admin/products/[id]/edit.vue")
  },
  {
    name: "supplier.products.edit",
    path: "/panel/products/:id()/edit",
    meta: edituVL22GNkvEvy6kK4lxbGSzpwBJOPxxZv_453ixSTX5H8MMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/panel/products/[id]/edit.vue")
  },
  {
    name: "warehouse.category.single",
    path: "/@:store_slug()/categories/:category_slug()",
    meta: _91category_slug_931fnDM8iWgJN_45y2AQuuNVngmDD3VNF7dAcE4SJWl5qOUMeta || {},
    component: () => import("F:/Projects/taminify_com-front/pages/@[store_slug]/categories/[category_slug].vue")
  },
  {
    name: "admin.withdraw-requests.list",
    path: "/admin/withdraw-requests",
    meta: { ...(index9XgY6i1e1hMNwVbK3B95gOZM5TU1T2VG4mew_pRBC4kMeta || {}), ...{"middleware":["auth","authority"]} },
    component: () => import("F:/Projects/taminify_com-front/pages/(subdomains)/admin/withdraw-requests/index.vue")
  },
  {
    name: component_45stubkYkKPjSnKaPaDPikbHaUPd4mS9NOOBaOZ_45kkFwfNJ9IMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubkYkKPjSnKaPaDPikbHaUPd4mS9NOOBaOZ_45kkFwfNJ9I
  }
]